import { api } from '@/lib/api';
import type { PagedResponse } from '@/features/companies/types';
import type {
  CompanyInformation,
  CompanyInformationStatus,
  SubmitCompanyInformationBody,
} from './types';

/** The server scopes the page to the caller: an admin sees every submission,
 *  anyone else sees only their own. The client sends no owner filter. */
export function listCompanyInformation(page: number, pageSize: number) {
  return api.get<PagedResponse<CompanyInformation>>(
    `/api/company-information?page=${page}&pageSize=${pageSize}`,
  );
}

export function submitCompanyInformation(body: SubmitCompanyInformationBody) {
  return api.post<CompanyInformation>('/api/company-information', body);
}

export function editCompanyInformation(id: number, body: SubmitCompanyInformationBody) {
  return api.patch<CompanyInformation>(`/api/company-information/${id}`, body);
}

/** Approving returns the new tenant's generated admin credentials; rejecting
 *  and un-approving return `{ ok: true }`. */
export interface ApprovedCompany {
  id: number;
  pathName: string;
  adminUsername: string;
  adminPassword: string;
}

export function setCompanyInformationStatus(id: number, status: CompanyInformationStatus) {
  return api.put<ApprovedCompany | { ok: true }>(
    `/api/company-information/${id}/status`, { status },
  );
}
